import React from "react";

import { formatDate } from '../common';
import { formatGps } from "../../../../utils/commonHelpers";

const formatOptions = {
  month: "short",
  day: "numeric",
  year: "numeric",
  hour: "numeric",
  minute: "numeric",
  second: "numeric",
};

function formatTimestamp(timestamp: Date): string {
  //return timestamp.toLocaleDateString("en-US", formatOptions);
  return formatDate(timestamp);
}

interface TootipProps {
  position: Position;
  timestamp: Date;
}

const Tooltip: React.FC<TootipProps> = ({ position, timestamp }) => {
  return (
    <div>
      <span>Location: {formatGps(position.lat, position.lng)}</span>
      <br />
      <span>{formatTimestamp(timestamp)}</span>      
    </div>
  );
};

export default Tooltip;

interface Position {
  lat: number;
  lng: number;
}

export function toolTipForAsset(
    position: Position,
    timestamp: Date
) {
    return (
        <Tooltip position={position} timestamp={timestamp} />
    );
}